import Carousel from './carousel';

class PictureTeaser extends Carousel {
  constructor(selector: HTMLElement | string) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const carousel: HTMLElement | null | undefined = el?.closest('.o-picture-teaser');
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-picture-teaser-slider__pagination');

    super(el, {
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: 1.25,
      spaceBetween: 25,
      loop: true,
      initialSlide:  window.innerWidth < 1024 ? 0 : 1,
      // autoplay: {
      //   delay: TIME,
      // },
      centeredSlides: true,
      navigation: {
        nextEl: selector instanceof HTMLElement ? selector.closest('.o-picture-teaser__row')?.querySelector('.swiper-button-next') : '.swiper-button-next',
        prevEl: selector instanceof HTMLElement ? selector.closest('.o-picture-teaser__row')?.querySelector('.swiper-button-prev') : '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      // on: {
      //   afterInit: () => {
      //     pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
      //   },
      // },
      observer: true,
      observeParents: true,
      breakpoints: {
        450: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 75,
        },
      },
    });
  }

  init() {
    super.init();
  }
}

export default PictureTeaser;
